export enum ServiceTypeCode {
  CARRY_IN = 'CI',
  MAIL_IN = 'MI',
  REMOTE_TECH = 'RT',
}
